// extracted by mini-css-extract-plugin
module.exports = {"container":"logout-dialog_container__3ia2k","logout-btn":"logout-dialog_logout-btn__jLhdl","cancel-btn":"logout-dialog_cancel-btn__2bAON"};